import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=69fa2ae6&"
import script from "./edit.vue?vue&type=script&lang=js&"
export * from "./edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\english\\new-evaluation\\src\\admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('69fa2ae6')) {
      api.createRecord('69fa2ae6', component.options)
    } else {
      api.reload('69fa2ae6', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=69fa2ae6&", function () {
      api.rerender('69fa2ae6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/questionBank/edit.vue"
export default component.exports